import AboutHeader from "../components/about/AboutHeader";
import AboutHero from "../components/about/AboutHero";
import CTASection from "../components/about/CTASection";
import FAQSection from "../components/about/FAQSection";
import FeaturesSection from "../components/about/FeaturesSection";
import MissionSection from "../components/about/MissionSection";
import Process2 from "../components/about/Process2";


const AboutPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <AboutHeader />
      <AboutHero />
      {/* <StatsSection /> */}
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <FeaturesSection />
        {/* <ProcessSection /> */}
        <Process2/>
        <FAQSection/>
        <MissionSection />
      </div>
      
      <CTASection />
    </div>
  );
};

export default AboutPage;